import { Component, Shark } from "shark-mvc";

import templateContent from "./display-sort-field.html";

class DisplaySortFieldComponent extends Component {
	defaultValue = "alfa-asc";

	constructor () {
		super("displaySortFieldComponent");

		this.addTemplate("", templateContent);
	}
	
	init () {
		const displaySortFieldSettings = Shark.getInstance("__smart__", {
			sort: this.defaultValue,
		});

		displaySortFieldSettings.onDataChanged = function () {
			localStorage.documentListDisplaySortField = this.sort;
			Shark.render();
		};

		const localStorageDisplaySortField = localStorage.documentListDisplaySortField || this.defaultValue;
		displaySortFieldSettings.sort = localStorageDisplaySortField;

		Shark.set({
			displaySortFieldSettings,
		});
	}

	sortFolderList (folderList) {
		const { displaySortFieldSettings } = Shark.get();
		let sortField;
		let sortDirection;

		switch (displaySortFieldSettings.sort) {
			case "alfa-asc":
				sortField = "name";
				sortDirection = 1;
				break;
			case "alfa-desc":
				sortField = "name";
				sortDirection = -1;
				break;
			case "creation-asc":
				sortField = "__createdAt";
				sortDirection = -1;
				break;
			case "creation-desc":
				sortField = "__createdAt";
				sortDirection = 1;
				break;
		}

		folderList.sort((a, b) => {
			try {
				if (a[sortField].toString().toLowerCase() > b[sortField].toString().toLowerCase()) {
					return 1 * sortDirection;
				}
				else if (a[sortField].toString().toLowerCase() < b[sortField].toString().toLowerCase()) {
					return -1 * sortDirection;
				}
			}
			catch (e) {}
		});
	}
}

const displaySortFieldComponent = new DisplaySortFieldComponent();

Shark.registerComponent(displaySortFieldComponent);

export default displaySortFieldComponent;
